<template>
  <v-dialog v-model="showNewsletterRegistrationDialog" scrollable max-width="552px">
    <v-card v-if="showNewsletterRegistrationDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline">{{ $t('content.newsletter.label') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click.native="showNewsletterRegistrationDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <v-container class="pa-0 ma-0" grid-list-md>
            <v-row>
              <v-col v-html="$t('content.newsletter.text')"/>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group
                  v-model="form.is_employee"
                  row
                  color="primary"
                >
                  <v-radio
                    :label="$t('content.contact.employees')"
                    :value="true"
                    color="primary"
                  />
                  <v-radio
                    :label="$t('content.contact.employers')"
                    :value="false"
                    color="primary"
                  />
                </v-radio-group>
                <v-autocomplete
                  :items="salutationItems"
                  v-model="form.sex"
                  :label="$t('texts.salutation')"
                  item-text="text"
                  item-value="value"
                  required
                  :error-messages="errors.collect('salutation')"
                  v-validate="'required'"
                  data-vv-name="salutation"
                  :data-vv-as="$t('texts.salutation')"
                />
                <v-text-field
                  :label="$t('texts.firstName')"
                  value=""
                  v-model="form.first_name"
                  required
                  :error-messages="errors.collect('firstName')"
                  v-validate="'required'"
                  data-vv-name="firstName"
                  :data-vv-as="$t('texts.firstName')"
                />
                <v-text-field
                  :label="$t('texts.lastName')"
                  v-model="form.last_name"
                  required
                  :error-messages="errors.collect('lastName')"
                  v-validate="'required'"
                  data-vv-name="lastName"
                  :data-vv-as="$t('texts.lastName')"
                />
                <v-text-field
                  v-if="!form.is_employee"
                  v-model="form.company_name"
                  :label="$t('texts.nameOfCompany')"
                  required
                  :error-messages="errors.collect('company_name')"
                  v-validate="'required'"
                  data-vv-name="company_name"
                  :data-vv-as="$t('texts.nameOfCompany')"
                />
                <v-text-field
                  :label="$t('texts.email')"
                  v-model="form.email"
                  required
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                  :data-vv-as="$t('texts.email')"
                />
              </v-col>
            </v-row>
          </v-container>
        </form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="submitForm()"
          :disabled="registerNewsletterPending"
          :loading="registerNewsletterPending"
        >
          {{ $t('texts.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showNewsletterRegistrationDialog: false,
      form: {},
    };
  },
  mounted() {
    this.$eventBus.$on('show-newsletter-registration-dialog', () => {
      this.reset();
      this.form.language = this.language;
      this.showNewsletterRegistrationDialog = true;
    });
  },
  computed: {
    ...mapUserState([
      'language',
      'registerNewsletterPending',
    ]),
    salutationItems() {
      const items = [
        { value: 1, text: this.$i18n.t('texts.salutationMr') },
        { value: 2, text: this.$i18n.t('texts.salutationMrs') },
      ];
      return items;
    },
  },
  methods: {
    ...mapUserActions([
      'registerNewsletter',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        sex: 1,
        first_name: '',
        last_name: '',
        email: '',
        language: '',
        is_employee: true,
        company_name: '',
      };
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonLoading = true;
          this.registerNewsletter(this.form).then(() => {
            this.showNewsletterRegistrationDialog = false;
          });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
